import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { FopModeService } from './../fop-mode/fop-mode.service';
import { LogService } from './../logging/log.service';
import { EnvService } from './../configuration/env.service';

@Injectable({
    providedIn: 'root'
})
export class WatchdogService implements OnDestroy {
    LOG_SOURCE = 'WatchdogService';

    subFopConfig: Subscription;
    subServerInterval: Subscription;
    subServerRequest: Subscription;
    subKeycloakInterval: Subscription;
    subKeycloakRequest: Subscription;

    constructor(
        private readonly logService: LogService,
        private readonly http: HttpClient,
        private readonly fopModeService: FopModeService,
        private readonly envService: EnvService
    ) {}

    start() {
        this.logService.info(this.LOG_SOURCE, 'Checking watchdog service config', {});
        this.subFopConfig = this.fopModeService.getFopConfig().subscribe(fopConfig => {
            if (fopConfig && fopConfig.serverWatchdogEnabled) {
                const requestInterval = 10000;
                this.subServerInterval = interval(requestInterval).subscribe(() => {
                    try {
                        this.http.get('/fop/watchdog').subscribe(resp => {
                            this.logService.verbose(this.LOG_SOURCE, 'Server watchdog response received', { resp });
                        });
                    } catch (error) {
                        this.logService.error(this.LOG_SOURCE, 'Server watchdog request failed', { error });
                    }
                });
                this.logService.info(this.LOG_SOURCE, 'Server watchdog service started', { requestInterval });
            } else {
                this.logService.info(this.LOG_SOURCE, 'Server watchdog service disabled', {});
            }
            if (fopConfig && fopConfig.keycloakWatchdogEnabled) {
                const requestInterval = 10000;
                this.subKeycloakInterval = interval(requestInterval).subscribe();
                try {
                    this.http.get(`${this.envService.config.keycloak.url}/realms/master`).subscribe(resp => {
                        this.logService.verbose(this.LOG_SOURCE, 'Keycloak response received', { resp });
                    });
                } catch (error) {
                    this.logService.error(this.LOG_SOURCE, 'Keyclaok request failed', { error });
                }
                this.logService.info(this.LOG_SOURCE, 'Keycloak watchdog service started', { requestInterval });
            } else {
                this.logService.info(this.LOG_SOURCE, 'Keycloak watchdog disabled', {});
            }
        });
    }

    ngOnDestroy() {
        if (this.subFopConfig) {
            this.subFopConfig.unsubscribe();
        }
        if (this.subServerInterval) {
            this.subServerInterval.unsubscribe();
        }
        if (this.subServerRequest) {
            this.subServerRequest.unsubscribe();
        }
        if (this.subKeycloakInterval) {
            this.subServerInterval.unsubscribe();
        }
        if (this.subKeycloakRequest) {
            this.subKeycloakRequest.unsubscribe();
        }
    }
}
